/**
 * Project API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ProjectTypeModel = 'CUSTOMER' | 'INTERNAL' | 'CROSS_CC';

export const ProjectTypeModel = {
    Customer: 'CUSTOMER' as ProjectTypeModel,
    Internal: 'INTERNAL' as ProjectTypeModel,
    CrossCc: 'CROSS_CC' as ProjectTypeModel
};

